<template>
  <div class="contact-btn__next" @click="handleClick">
    <router-link
      :event="enabled ? `click` : ``"
      :id="stepTagId"
      class="contact-btn__next--btn"
      :class="{ active: enabled }"
      :to="stepPath"
    >
      次へ<i class="atlas-glyphs-m-arrow-right"></i>
    </router-link>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const props = defineProps({
  enabled: {
    type: Boolean,
    required: true
  }
});
const emit = defineEmits(['click']);

const route = useRoute();

const stepPath = computed(() => {
  const nextStepNumber = props.enabled
    ? route.meta.order + 1
    : route.meta.order;
  return { path: `/step${nextStepNumber}`, query: route.query };
});
const stepTagId = computed(() => {
  return `next${route.meta.order}_slide`;
});

const handleClick = () => {
  emit('click');
};
</script>
